import 'url-search-params-polyfill';
import 'url-polyfill';

const urlSearchParams = (url) => new URLSearchParams(url.search);

const paramPresent = (param) => {
  let url = new URL(document.URL);
  let searchParams = urlSearchParams(url);
  return searchParams.has(param) ? true : false;
};

const getParamFromURL = (param) => {
  let url = new URL(document.URL);
  let searchParams = urlSearchParams(url);
  return searchParams.get(param);
};

const updateURLParams = (stateToStore) => {
  let url = new URL(document.URL);
  let searchParams = urlSearchParams(url);

  for(const [key, value] of Object.entries(stateToStore)) {
    if(!value) {
      searchParams.delete(key)
    } else {
      searchParams.set(key, value);
    }
  }

  url.search = searchParams.toString();
  return `${url.pathname}${url.search}${url.hash}`;
}

export default {
  urlSearchParams,
  paramPresent,
  getParamFromURL,
  updateURLParams
}